export class ChangePassword {
	type: string = "PIN" || "PASSWORD";
	oldKey: string = null;
	newPassword: string = null;
	confirmPassword: string = null;
}
